/// <reference path="../../../../components/models/meevo.model.custom.ts" />

angular.module('ApptBookApp').directive('hideCurrentPopup', ['appointmentBookGlobalsService', globals => {
    return {
        restrict: 'A',
        link: function (scope : any, element, attrs) {
            var mouseUpHandler = function (e) {
                if (globals.currentPopupId != undefined) {
                    var container = $("#" + globals.currentPopupId);
                    if ((!container.is(e.target) // if the target of the click isn't the container...
                        && container.has(e.target).length === 0 // ... nor a descendant of the container...
                        && !(e.target.class == "appt_menu_button") //...nor the menu's button...
                        && $(e.target).closest(".appt_menu_button").length === 0) //...nor one of that buttons descendants...
                        || $(e.target).is("button")) // or is a button within container
                    {
                        let workTicketPrintIcon = $('.wt-print-highlight > .wt-print > svg > path')
                        workTicketPrintIcon.css('fill', '#fff')
                        container.hide();
                        globals.currentPopupId = undefined;
                    }
                }
            }
            $(document).off("mouseup", mouseUpHandler).on("mouseup", mouseUpHandler);
        }
    }
}]);

angular.module('ApptBookApp').directive('toggleDayOfWeekButton', [() => {
    return {
        restrict: 'E',
        scope: {
            model: "=ngModel",
            contentKey: "@",
            disabled: "=ngDisabled",
            maxNumberOfDays: "=?"
        },
        template: '<div ng-click="click()"><div><div class="circle_day_picker" ng-class="{\'circle_day_picker_alt\': isSelected}" layout=\'row\' layout-align=\'center center\'><label  translate="{{::contentKey}}" > </label></div></div></div>',
        link: function (scope, element, attrs) {
            var day = parseInt(attrs.dayOfWeek);
            scope.$watchCollection("model", function () {
                if (scope.model) {
                    scope.isSelected = scope.model.indexOf(day) >= 0; //scope.model.includes(day); includes is experimental and might not be supported in chrome 42
                }
            });
            scope.click = function () {
                if (!scope.disabled) {
                    if (scope.model && scope.model.indexOf(day) >= 0) {
                        scope.model.splice(scope.model.indexOf(day), 1);
                    } else if (scope.maxNumberOfDays == null || (scope.maxNumberOfDays != null && scope.model && scope.model.length < scope.maxNumberOfDays)) {
                        scope.model.push(day);
                    }
                    // if you have a max of 1 selected day then enable swapping your day to any day that is selected.
                    else if (scope.maxNumberOfDays != null && scope.model && scope.maxNumberOfDays == scope.model.length && scope.maxNumberOfDays == 1) {
                        scope.model.splice(0, 1);
                        scope.model.push(day);
                    }
                }
            }

        }
    }
}]);

angular.module('ApptBookApp').directive('scrollIf', [() => {
    return function (scope, element, attrs) {
        scope.$watch(attrs.scrollIf, function (value) {
            if (value) {
                element.parent().scrollTop(0);
                var childOffsetInParent = element.offset().top - element.parent().offset().top;
                if (childOffsetInParent + element.height() > element.parent().height()) {
                    var scrollTop = element.height() - (element.parent().height() - childOffsetInParent);
                    element.parent().scrollTop(scrollTop);
                }
            }
        });
    }
}]);
